var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":"/artist/profile/" + _vm.user.username}},[_c('v-card',{staticClass:"user-card"},[_c('v-card-title',[_vm._v(_vm._s(_vm.user.fullName))]),_c('v-card-subtitle',[_vm._v(_vm._s(_vm.user.username))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }